import { render } from "./App.vue?vue&type=template&id=2679aaa7"
const script = {}

import exportComponent from "C:\\Users\\Michael.Mathu\\Documents\\Projects\\unique_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__